import { ComponentsLibModule } from '@ccab/components-lib';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CertificatesComponent } from './pages/certificates/certificates.component';

import { CertificatesRoutingModule } from './certificates-routing.module';
import { MatchmakingRoutingModule } from '../matchmaking/matchmaking-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { certificateNavbarComponent } from './components/certificates-navbar/certificate-navbar.component';

import { CertificateOriginStatusLabelComponent } from './components/origin-certificate-status-label/origin-certificate-status-label.component';
import { OriginCertificateComponent } from './pages/certificates-origin/origin-certificate.component';
import { ModalConsularApprovalComponent } from './modals/modal-consular-approval/modal-consular-approval.component';
import { ModalNotificationTemplateComponent } from './modals/modal-notification-template/modal-notification-template.component';
import { ModalImportOriginCertificateComponent } from './modals/modal-import-origin-certificate/modal-import-origin-certificate.component';
import { SearchOriginCertificateComponent } from './components/search-origin-certificate/search-origin-certificate.component';
import { NewOriginCertificateComponent } from './pages/new-origin-certificate/new-origin-certificate.component';
import { InvoiceFormComponent } from './components/invoice-form/invoice-form.component';
import { CompanyManagementComponent } from './components/company-management/company-management.component';
import { ExportationProductsComponent } from './components/exportation-products/exportation-products.component';
import { ExportationProductFormComponent } from './components/exportation-products/exportation-product-form/exportation-product-form.component';
import { ProductExportationGridComponent } from './components/exportation-products/product-exportation-grid/product-exportation-grid.component';
import { TableOriginCertificateComponent } from './components/origin-certificate-table/origin-certificate-table.component';
import { OriginCertificateDetailComponent } from './pages/origin-certificate-detail/origin-certificate-detail.component';
import { CompaniesInvolvedComponent } from './components/companies-involved/companies-involved.component';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { ModalCertificateEdit } from './modals/modal-certificate-edit/modal-certificate-edit.component';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';

@NgModule({
  declarations: [
    CertificatesComponent,
    SearchOriginCertificateComponent,
    CompaniesInvolvedComponent,
    OriginCertificateDetailComponent,
    OriginCertificateComponent,
    ProductExportationGridComponent,
    ExportationProductFormComponent,
    ExportationProductsComponent,
    CompanyManagementComponent,
    InvoiceFormComponent,
    NewOriginCertificateComponent,
    ModalImportOriginCertificateComponent,
    ModalNotificationTemplateComponent,
    certificateNavbarComponent,
    ModalConsularApprovalComponent,
    TableOriginCertificateComponent,
    OriginCertificateComponent,
    CertificateOriginStatusLabelComponent,
    ModalCertificateEdit
  ],
  imports: [
    CommonModule,
    CertificatesRoutingModule,
    MatchmakingRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    TourMatMenuModule,
    ComponentsLibModule,
    MatSelectInfiniteScrollModule
  ]
})
export class CertificatesModule {}
